const CLIENTS: ReadonlyArray<{ name: string; logo: string }> = [
  { name: 'TokyoMedic', logo: '/assets/logos/tokyomedic.png' },
  { name: 'Elevani Industries', logo: '/assets/logos/elevani.png' },
  { name: '48by40', logo: '/assets/logos/48by40.svg' },
  { name: 'Prescient Security', logo: '/assets/logos/prescient.png' },
];

export function LogoStrip(): React.JSX.Element {
  return (
    <div className="logo-strip">
      {CLIENTS.map((c) => (
        <img key={c.name} src={c.logo} alt={c.name} loading="lazy" height={34} />
      ))}
    </div>
  );
}
